import React from "react";
import {Link} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {GenericEntityDeleteContentProps, GenericEntityNoLinkedDelete} from "../../common/delete";
import {extractEntitiesByType} from "../../../models/error";
import ROUTES from "../../../routes/routes";
import {UnitDTO} from "../../../models/library";

const UnitRenderDelete: React.FC<GenericEntityDeleteContentProps> = (props: GenericEntityDeleteContentProps) => {
    //== Init =================================================================
    const [t] = useTranslation("libraries");
    const inputVariables = extractEntitiesByType(props.error, "InputVariable");
    const indicators = extractEntitiesByType(props.error, "Indicator");
    const units = extractEntitiesByType(props.error, "Unit");
    const values = extractEntitiesByType(props.error, "Value");
    const tPrefix = "definitions.units.confirm_delete.render";
    //== Render ===============================================================
    return (
        <ul>
            {inputVariables.length > 0 && (
                <li>
                    {t(`${tPrefix}.inputVariables`, {count: inputVariables.length})}
                    <ul>
                        {inputVariables.map((item) => (
                            <li key={item.id}>
                                <Link href={ROUTES.inputVariable.create(item.id)} target="_blank">
                                    {item.displayName}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </li>
            )}
            {indicators.length > 0 && (
                <li>
                    {t(`${tPrefix}.indicators`, {count: indicators.length})}
                    <ul>
                        {indicators.map((item) => (
                            <li key={item.id}>
                                <Link href={ROUTES.library.create(item.parentId ?? "not-found")} target="_blank">
                                    {item.displayName}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </li>
            )}
            {units.length > 0 && (
                <li>
                    {t(`${tPrefix}.units`, {count: units.length})}
                    <ul>
                        {units.map((item) => (
                            <li key={item.id}>
                                <Link href={ROUTES.unit.create(item.id)} target="_blank">
                                    {item.displayName}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </li>
            )}
            {values.length > 0 && <li>{t(`${tPrefix}.values`, {count: values.length})}</li>}
        </ul>
    );
};

interface UnitDeleteProps {
    entity: UnitDTO | null;
    onDeleted: () => void;
    onCancel: () => void;
    onFailed: () => void;
}

export const UnitDelete: React.FC<UnitDeleteProps> = (props: UnitDeleteProps) => {
    return (
        <GenericEntityNoLinkedDelete
            tNs="libraries"
            tPrefix="definitions.units"
            urlSlug="units"
            RenderContent={UnitRenderDelete}
            {...props}
        />
    );
};
